/**
 * Estimates the visible behavior-canvas area in world coordinates (zoom = 1, offset = 0).
 * Used when seeding default node positions before the detail canvas is mounted.
 */
export function getBehaviorCanvasViewportSize(): {
  width: number;
  height: number;
} {
  if (typeof window === "undefined") {
    return { width: 1280, height: 720 };
  }

  // Rough chrome subtracted for editor tabs, breadcrumb and side palettes.
  const SIDE_CHROME_PX = 560;
  const TOP_CHROME_PX = 120;

  return {
    width: Math.max(480, window.innerWidth - SIDE_CHROME_PX),
    height: Math.max(320, window.innerHeight - TOP_CHROME_PX),
  };
}
